{
  "title": "Mis perfiles",
  "empty": "Aquí no hay nada todavía: las invitaciones para completar un perfil aparecerán en esta página.",
  "active": {
    "title": "Activos",
    "start": "Comienza tu perfil de {{tenantName}}",
    "continue": "Continúa tu perfil de {{tenantName}}"
  },
  "completed": {
    "title": "Completados",
    "submittedOn": "Completado el {{date}}"
  },
  "detail": {
    "back": "Volver a Mis perfiles",
    "self": "Autoperfil",
    "preparing": "Tu evaluación se está preparando; te avisaremos por correo cuando esté lista.",
    "notFound": "No encontramos este perfil."
  }
}
